"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

(function (webf) {
  webf.lang.en = webf.lang.en || {};
  webf.lang.en.ajaxform = {
    required: function required(name) {
      return "the field " + name + " is required";
    }
  };
})(_core["default"]);